import ReactTable from 'react-table';
import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { getUserId, getRole } from 'constants/localStorageManager';

import { USERS } from 'constants/Users';
import {
  ADDONS,
  REQUESTED,
  ACTIVATED,
  REJECTED,
  SOCIAL_MEDIA,
  SOCIAL_REVIEW,
} from 'constants/AddOns';
import { iconForStatus } from 'utils/addOnHelpers';
import BusinessApi from 'apis/Business';
import UpgradeToPro from 'components/Banners/upgradeToPro';
import Toaster from 'components/Toaster';
import UpgradeSubscription from 'components/subscriptionFeature/upgradeSubscription';
import { checkPlanValidity } from 'utils/plansHelper';
import OtherMediaAddOnModal from './OtherMediaAddOnModal';
import SocialMediaAddOnModal from './SocialMediaAddOnModal';

const MEDIA_TYPE = 'media_type';
const REVIEW_TYPE = 'review_type';

class RequestAddOns extends Component {
  constructor() {
    super();
    this.state = {
      data: {},
      btn: REQUESTED,
      businessAddons: [],
      showModal: false,
      activeModal: '',
      isUpgradeModalVisible: false,
    };
  }

  componentWillMount() {
    this.fetchBusinessDetail();
  }

  fetchBusinessDetail = () => {
    const { editId } = this.props;
    this.setState({ isLoading: true });

    BusinessApi.getDetails(editId)
      .then(({ data }) => {
        this.updateListData(data);
        this.setState({ isLoading: false });
      })
      .catch(() => {
        Toaster.getErrorToaster('exclamation-triangle', 'Error fetching data');
        this.setState({ isLoading: false });
      });
  };

  updateListData = data => {
    const { business_addons } = data;

    const values = ADDONS.map(addon => {
      const businessAddon =
        business_addons &&
        business_addons.find(ad => ad.addon_price_id === addon.addon_price_id);

      return {
        ...addon,
        status: businessAddon ? businessAddon.status : 'Not Requested',
        id: businessAddon && businessAddon.id,
      };
    });

    this.setState({
      data,
      businessAddons: values,
    });
  };

  activateAddOns = () => {
    if (!checkPlanValidity()) {
      this.toggleUpgradeModal();
      return;
    }
    const { businessAddons } = this.state;
    const userId = getUserId();

    const unActivatedBusinessAddons = businessAddons.filter(
      addon => !addon.status || addon.status === REQUESTED
    );

    const business_addons_attributes = unActivatedBusinessAddons.map(
      ({ addon_price_id, id }) => {
        return {
          id,
          status: ACTIVATED,
          approved_on: new Date().toGMTString(),
          approver_id: userId,
          addon_price_id,
        };
      }
    );

    this.updateBusinessAddOn(business_addons_attributes);
  };

  requestAddOns = () => {
    if (!checkPlanValidity()) {
      this.toggleUpgradeModal();
      return;
    }
    const { businessAddons } = this.state;
    const userId = getUserId();

    const unActivatedBusinessAddons = businessAddons.filter(
      addon => addon.status !== REQUESTED
    );

    const business_addons_attributes = unActivatedBusinessAddons.map(badd => {
      return {
        status: REQUESTED,
        requester_id: userId,
        requested_on: new Date().toGMTString(),
        addon_price_id: badd.addon_price_id,
      };
    });

    this.updateBusinessAddOn(business_addons_attributes);
  };

  updateBusinessAddOn = updatedData => {
    const { editId } = this.props;

    const data = {
      business: {
        business_addons_attributes: { ...updatedData },
      },
    };

    BusinessApi.update(editId, data)
      .then(() => {
        this.fetchBusinessDetail();
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully updated Add-ons status.'
        );
      })
      .catch(() =>
        Toaster.getErrorToaster('exclamation-triangle', 'Error updating addons')
      );
  };

  addOnButton = () => {
    if (!checkPlanValidity()) {
      return <UpgradeToPro />;
    }

    const { businessAddons } = this.state;

    const activatedAddOns =
      businessAddons.slice().filter(addon => addon.status === ACTIVATED)
        .length === ADDONS.length;

    if (activatedAddOns) {
      return null;
    }

    const pendingAddOns =
      businessAddons
        .slice()
        .filter(
          addon => addon.status === REJECTED || addon.status === REQUESTED
        ).length > 0;

    if (pendingAddOns) {
      if (getRole() === USERS.ADMIN) {
        return (
          <Button
            className="btn-primary float-right"
            onClick={this.activateAddOns}
          >
            Activate
          </Button>
        );
      }
      return (
        <Button className="btn-secondary float-right">
          Pending Activation
        </Button>
      );
    }

    if (getRole() === USERS.ADMIN) {
      return (
        <Button
          className="btn-primary float-right"
          onClick={this.activateAddOns}
        >
          Activate
        </Button>
      );
    }

    return (
      <Button className="btn-primary float-right" onClick={this.requestAddOns}>
        Request Activation
      </Button>
    );
  };

  toggleModal = () => {
    this.setState(
      {
        activeModal: '',
      },
      this.fetchBusinessDetail
    );
  };

  toggleUpgradeModal = () => {
    this.setState(({ isUpgradeModalVisible }) => ({
      isUpgradeModalVisible: !isUpgradeModalVisible,
    }));
  };

  onActionClick = (status, addOnName) => {
    if (!checkPlanValidity()) {
      this.toggleUpgradeModal();
      return;
    }
    if (status !== ACTIVATED) {
      return;
    }
    this.setState({
      activeModal: addOnName,
    });
  };

  selectModal = () => {
    const { data, activeModal } = this.state;
    const { editId } = this.props;
    const { social_reviews, social_medias } = data;

    switch (activeModal) {
      case SOCIAL_REVIEW:
        const {
          social_reviews,
          social_review_addon,
          name: businessName,
        } = data;

        return (
          <OtherMediaAddOnModal
            type={REVIEW_TYPE}
            title={data.name}
            businessId={editId}
            isVisible
            toggleModal={this.toggleModal}
            data={social_reviews}
            socialReviewAddon={social_review_addon}
            fetchBusinessDetail={this.fetchBusinessDetail}
            businessName={businessName}
          />
        );
      case SOCIAL_MEDIA:
        const { social_medias, social_media_addon, name } = data;

        return (
          <SocialMediaAddOnModal
            type={MEDIA_TYPE}
            title={data.name}
            businessId={editId}
            isVisible
            toggleModal={this.toggleModal}
            data={social_medias}
            socialMediaAddon={social_media_addon}
            fetchBusinessDetail={this.fetchBusinessDetail}
            businessName={name}
          />
        );
      default:
        return null;
    }
  };

  render() {
    const { data, businessAddons, isUpgradeModalVisible } = this.state;

    const columns = [
      {
        Header: 'Available Add-Ons',
        accessor: 'addOnName',
        Cell: ({ original }) => (
          <Fragment>
            <div className="float-left ml-2 mt-2">
              <FontAwesomeIcon icon={original.logo} className="" />
            </div>
            <div className="list-title float-left">{original.addOnName}</div>
          </Fragment>
        ),
      },
      {
        id: 'status',
        Header: 'Status',
        Cell: ({ original }) => {
          const property = iconForStatus(original.status);

          return (
            <div>
              {property && <FontAwesomeIcon {...property} />}
              <span className="text-capitalize list-title">
                {original.status || 'Not Requested'}
              </span>
            </div>
          );
        },
        width: 300,
      },
      {
        Header: 'Actions',
        sortable: false,
        width: 200,
        Cell: ({ original }) => {
          let style = '';

          if (original.status === ACTIVATED) {
            style = 'icon-check';
          } else {
            style = 'icon-disable';
          }

          return (
            <React.Fragment>
              <span
                className={`circular-icon ${style}`}
                onClick={() => {
                  this.onActionClick(original.status, original.addOnName);
                }}
                role="none"
              >
                <FontAwesomeIcon icon="pencil-alt" />
              </span>
            </React.Fragment>
          );
        },
      },
    ];

    const tableData = businessAddons.filter(
      addon => addon.addon_price_id !== 3
    );

    return (
      <React.Fragment>
        {this.selectModal()}
        <div
          className={`row ${
            getRole() !== USERS.ADMIN ? 'd-flex' : 'd-block'
          } justify-content-between pt-4 mx-auto`}
        >
          {getRole() !== USERS.ADMIN && <h3>{data.name}</h3>}
          {this.addOnButton()}
        </div>
        <UpgradeSubscription
          isUpgradeModalVisible={isUpgradeModalVisible}
          toggleUpgradeModal={this.toggleUpgradeModal}
          type="addons"
        />
        <ReactTable
          className="mt-5"
          data={tableData}
          columns={columns}
          minRows={tableData.length}
          showPagination={false}
        />
      </React.Fragment>
    );
  }
}

export default RequestAddOns;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/info-edit/RequestAddOns.js